<template>
  <van-nav-bar
    :title="title"
    left-arrow
    @click-left="onClickLeft"
  />
</template>
<script>
export default {
  name:'navBar',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClickLeft() {
      this.$emit('back')
    }
  }
}
</script>
<style lang="stylus" scoped>
  /deep/.van-nav-bar__left {
    // padding: 0 5px;
    font-size: 24px;
  }
  /deep/.van-nav-bar__title {
    font-size: 18px;
    color: #333;
    font-weight: bold;
    font-family: PingFangSC-Regular
  }
</style>